import { forEach } from "lodash";
import { clearExportEventSchedule, setExportEventCeremony, setExportEventDetail, setExportJudgingSession, setExportMatcheSession } from "./exportScheduleActions";
import ScheduleSession from "models/ScheduleSession";
import { parseTimeForScheduler, parseDateForScheduler } from 'utils/dateTimeUtils';
import { IN_PERSON_OFFICIAL,IN_PERSON_TEST } from 'shared/constants/eventTypes';
import { ExportMatchTypes } from 'shared/constants/matchTypes';

 const ImportScheduleEntries = (isDownloading,isResetSchedule) => {
  return async (dispatch, getState) => {
    const {auth: { userInfo: { use_24_hour_format } }, event: {eportEventSchedule, eventDetails,eventSchedule}} = getState();
   
      const { id:eventId,eventScheduleId, time_zone, isEventDateChanged } = eventDetails;
      const { title : eventName,event_type,start_date, end_date } = eventDetails.attributes;
      const { ExportHeader } = eportEventSchedule;
      let data = "";
     
       const getExportEventData = async() => {
            const eventDetail = 
                              {
                                eventId: eventId,
                                eventName: eventName,
                                start_date: start_date? parseDateForScheduler(start_date): '',
                                end_date: end_date? parseDateForScheduler(end_date): ''
                              }
                            
            dispatch(setExportEventDetail(eventDetail));
        
          }
        
        const getExportCeremonyData =async ()=>{
            const openingSessionData=eventSchedule.openingSessionData;
            const openingSessionIncluded=eventSchedule.openingSessionIncluded;
            const closingSessionData=eventSchedule.closingSessionData;
            const closingSessionIncluded=eventSchedule.closingSessionIncluded;
            const openingSession = new ScheduleSession(openingSessionData, openingSessionIncluded);
            const closingSession = new ScheduleSession(closingSessionData, closingSessionIncluded)

            const openingStartTime = openingSession.parseStartTimeForScheduler(time_zone, use_24_hour_format);
            const openingEndTime = openingSession.parseEndTimeForScheduler(time_zone, use_24_hour_format);

            const closingStartTime = closingSession.parseStartTimeForScheduler(time_zone, use_24_hour_format);
            const closingEndTime = closingSession.parseEndTimeForScheduler(time_zone, use_24_hour_format);

            const openingDate=openingSession.parseStartDateOnlyForScheduler();
            const closingDate=closingSession.parseEndDateOnlyForScheduler();
            let ceremonyOpenDate='';
            let ceremonyCloseDate='';

            //flag isEventDateChanged get false once 'set schedule' succeeded or return back to all events
            if(isEventDateChanged && isDownloading && !isResetSchedule)
            {
               ceremonyOpenDate= start_date== end_date ? parseDateForScheduler(start_date): '';
               ceremonyCloseDate= start_date== end_date ? parseDateForScheduler(start_date): '';
            }
            else{
                ceremonyOpenDate= openingDate? openingDate: start_date== end_date ? parseDateForScheduler(start_date): '';
                ceremonyCloseDate= closingDate? closingDate: start_date== end_date? parseDateForScheduler(start_date): '';
               
            }
            const ceremonydata={
                    openCeremony:{
                        eventName: eventName,
                        type: 'Opening Ceremony', 
                        id:openingSessionData.id,
                        scheduleId:eventScheduleId,
                        date: ceremonyOpenDate,
                        start_time: openingStartTime? openingStartTime.toUpperCase():'',
                        end_time: openingEndTime? openingEndTime.toUpperCase():'',
                        panelId: '',
                        panelName: '',
                        teamNumber: '',
                        teamName: '',           
                    } , 
                    closeCeremony: {
                        eventName: eventName,
                        type: 'Closing Ceremony', 
                        id:closingSessionData.id,
                        scheduleId:eventScheduleId,
                        date: ceremonyCloseDate,
                        start_time: closingStartTime? closingStartTime.toUpperCase():'',
                        end_time: closingEndTime? closingEndTime.toUpperCase():'',
                        panelId: '',
                        panelName: '',
                        teamNumber: '',
                        teamName: '',   
                    }
            }
                dispatch(setExportEventCeremony(ceremonydata))
                return ceremonydata;
        }

        const getExportJudgingSessionData = async() => {

                const formattedSessions= eventSchedule.sessions.judgingSessions;
                const judgingSessions = formattedSessions.map(session => {

                  let judgingSessionDate='';
                   
                   //flag isEventDateChanged get false once 'set schedule' succeeded or return back to all events
                    if(isEventDateChanged && isDownloading && !isResetSchedule)
                    {
                      judgingSessionDate= start_date== end_date? parseDateForScheduler(start_date): '';
                    }
                    else{
                        judgingSessionDate= session.startTime? parseDateForScheduler(session.startTime): start_date== end_date? parseDateForScheduler(start_date): '';
                    }
        
                    return {
                    eventName: eventName,
                    type: session.sessionType,
                    id:session.id,
                    scheduleId:eventScheduleId,
                    date: judgingSessionDate,
                    start_time: session.startTime? time_zone ? parseTimeForScheduler(session.startTime, time_zone, use_24_hour_format).toUpperCase() : parseTimeForScheduler(session.startTime, use_24_hour_format).toUpperCase() : '',
                    end_time: session.endTime? time_zone ? parseTimeForScheduler(session.endTime, time_zone, use_24_hour_format).toUpperCase() : parseTimeForScheduler(session.endTime, use_24_hour_format).toUpperCase() : '',
                    panelId: session.exportPanelId??'',
                    panelName: session.panelName??'',
                    teamNumber: session.exportteamNumber,
                    teamName: session.exportteamName,     
                    }
                })
            
                dispatch(setExportJudgingSession(judgingSessions));
                return judgingSessions;
            
                }
 const getExportMatchesSessionData = async() => {
  
      const isInPerson = event_type === IN_PERSON_OFFICIAL || event_type === IN_PERSON_TEST;
      const formattedSessions= eventSchedule.sessions.scoringSessions;
      const scoringPanelData=eventSchedule.sessions.scoringPanelData;

      const matchesSessions = formattedSessions.map(session => {
        let matchSessionDate='';
                   
                   //flag isEventDateChanged get false once 'set schedule' succeeded or return back to all events
                    if(isEventDateChanged && isDownloading && !isResetSchedule)
                    {
                      matchSessionDate= start_date== end_date? parseDateForScheduler(start_date): '';
                    }
                    else{
                        matchSessionDate= session.startTime? parseDateForScheduler(session.startTime): start_date== end_date? parseDateForScheduler(start_date): '';
                    }

            return {
                  eventName: eventName,
                  id:session.id,
                  scheduleId:eventScheduleId,
                  type: isInPerson? ExportMatchTypes(session.matches[0].matchTypeId,session.matches[0].matchNumber):ExportMatchTypes(session.matches[0].matchTypeId), 
                  matchNumber: session.sessionType?.includes("Practice")? "" : session.matches[0].matchNumber.toString(),
                  date: matchSessionDate,
                  start_time: session.startTime? time_zone ? parseTimeForScheduler(session.startTime, time_zone, use_24_hour_format).toUpperCase() : parseTimeForScheduler(session.startTime, use_24_hour_format).toUpperCase() : '',
                  end_time: session.endTime? time_zone ? parseTimeForScheduler(session.endTime, time_zone, use_24_hour_format).toUpperCase() : parseTimeForScheduler(session.endTime, use_24_hour_format).toUpperCase() : '',
                  panelId: session.panelId??'',
                  panelName:session.panelId? scoringPanelData.find(panel=>panel.id===session.panelId)?.name:'',
                  teamNumber: session.exportteamNumber,
                  teamName: session.exportteamName,     
            }
      
          })
  
        matchesSessions.sort((a, b) => a.matchNumber.localeCompare(b.matchNumber));
      
          dispatch(setExportMatcheSession(matchesSessions));
          return matchesSessions;
    
      }

    
        try {
    
            dispatch(clearExportEventSchedule());
            await getExportEventData();
             const eventCereMony= await getExportCeremonyData();
             const judgingSessions= await getExportJudgingSessionData();
             const matchesSessions= await getExportMatchesSessionData();
            
              const openCeremony=eventCereMony.openCeremony;
              const closeCeremony=eventCereMony.closeCeremony;
            
              data = `${ExportHeader.eventName},${ExportHeader.type},${ExportHeader.date},${ExportHeader.start_time},${ExportHeader.end_time},${ExportHeader.panelName},${ExportHeader.teamNumber},${ExportHeader.teamName}\n`;
              data += `${openCeremony.eventName},${openCeremony.type},${openCeremony.date},${openCeremony.start_time},${openCeremony.end_time},${openCeremony.panelName},${openCeremony.teamNumber},${openCeremony.teamName}\n`;
              data += `${closeCeremony.eventName},${closeCeremony.type},${closeCeremony.date},${closeCeremony.start_time},${closeCeremony.end_time},${closeCeremony.panelName},${closeCeremony.teamNumber},${closeCeremony.teamName}\n`;
            
             forEach(judgingSessions, (session) => {
               data += `${session.eventName},${session.type},${session.date},${session.start_time},${session.end_time},${session.panelName},${session.teamNumber},${session.teamName}\n`;
             });

             matchesSessions.forEach((session) => {
               data += `${session.eventName},${session.type},${session.date},${session.start_time},${session.end_time},${session.panelName},${session.teamNumber},${session.teamName}\n`;
                
             });

                return data;
    
        } catch (error) {
            throw error;

        }

  }
}

export const ImportScheduleEntriesAction = (isDownloading,isResetSchedule) => {
    return async (dispatch, getState) => {
        try {
        const data = await dispatch(ImportScheduleEntries(isDownloading,isResetSchedule));
        return data;
        } catch (error) {
        throw error;
        }
    };
};